angular.module("ticketco/ticketbuyer/signature", [
  "ticketco/ticketbuyer/common",
]);